module.exports = __webpack_public_path__ + "img/media-31.429a7169.png";